import React, { useCallback, useEffect, useState } from 'react';
import { MdPrint as MdPrintIcon } from 'react-icons/md';
import WrapperSubTitleForm from '../../../components/UI/WrapperSubTitleForm';
import useStyle, {
  ButtonImprimir, CardInfo, CardTop, ContainerDistribuicaoValores,
} from './FichaFinanceiraStyle';
import LoadingUI from '../../../components/UI/Loading/LoadingUI';
import TabCardLayoutAccordion from '../../../layouts/TabCardLayoutAccordion/TabCardLayoutAccordion';
import TabModel from '../../../models/TabModel';
import TabPanel from '../../../components/UI/TabPanel/TabPanel';
import FichaAnalíticaComponent from './Analitica/FichaAnalítica';
import FichaSinteticaComponent from './Sintetica/FichaSintetica';
import { downloadFichaFinanceira, findDistribuicaoValoresFichaFinanceira, findResumoFichaFinanceira } from '../../../services/core/processos/processosFichaFinanceira';
import {
  getMoneyMask,
  openPageFileBase64, toastUnmappedException,
} from '../../../helpers';
import { loadingInspecaoProcessoController } from '../loadingInspecaoProcessoController';
import { blue } from '../../../helpers/constants/colors.constants';
import { HrColored } from '../../ContaCorrenteHonorario/ContaCorrenteHonorarioStyles';
import { dadosPagamentoFactory } from '../../../services/core/processos/fichaFinanceiraValoresDistribuidos.factory';

function FichaFinanceiraComponent({ setLoadings, idProcesso }) {
  const style = useStyle();

  const [dadosPagamento, setDadosPagamento] = useState(dadosPagamentoFactory());
  const [dadosPagamentoDireto, setDadosPagamentoDireto] = useState(dadosPagamentoFactory());
  const [dadosInicio, setDadosInicio] = useState(dadosPagamentoFactory());

  const [columnOrdenacaoSintetica, setColumnOrdenacaoSintetica] = useState({
    order: 'DESC',
    element: 'dataLancamento',
  });

  const [columnOrdenacaoAnalitica, setColumnOrdenacaoAnalitica] = useState({
    order: 'DESC',
    element: 'dataLancamento',
  });

  const [activeTab, setActiveTab] = useState(0);
  const [settingsResumo, setSettingsResumo] = useState({
    valorCliente: 0,
    valorAbe: 0,
    valorComercial: 0,
    valorNegociador: 0,
    quitacaoTitulos: '',
    distribuicaoValoresDevedor: '',
    distribuicaoFichaFinanceira: '',
  });

  const [tabItens] = useState([
    new TabModel('tab-analitica', 0, 'Analítica', 'scrollable-auto-tabpanel'),
    new TabModel('tab-sintética', 1, 'Sintética', 'scrollable-auto-tabpanel'),
  ]);

  const configureStatesResumo = useCallback((data) => {
    setSettingsResumo({
      valorCliente: data.valorCliente ?? 0,
      valorAbe: data.valorAbe ?? 0,
      valorComercial: data.valorComercial ?? 0,
      valorNegociador: data.valorNegociador ?? 0,
      quitacaoTitulos: data.quitacaoTitulos,
      distribuicaoValoresDevedor: data.distribuicaoValoresDevedor,
      distribuicaoFichaFinanceira: data.distribuicaoFichaFinanceira,
    });
  }, [setSettingsResumo]);

  const changeTabViewHandler = useCallback((activeTabParam) => {
    setActiveTab(activeTabParam);
  }, [setActiveTab]);

  async function handlePrintFichaFinanceira() {
    try {
      let ordenacao;
      setLoadings(loadingInspecaoProcessoController.changeLoadingFichaFinaceira(true));
      if (activeTab === 1) {
        ordenacao = columnOrdenacaoSintetica;
      } else {
        ordenacao = columnOrdenacaoAnalitica;
      }

      const httpResponse = await downloadFichaFinanceira(idProcesso, activeTab, [`${ordenacao.element},${ordenacao.order}`]);
      if (httpResponse.data.length > 0) {
        openPageFileBase64(httpResponse.data, httpResponse.headers['content-type']);
      }
    } catch (err) {
      toastUnmappedException(
        err,
        'Ocorreu um problema ao tentar abrir o relatório',
      );
    } finally {
      setLoadings(loadingInspecaoProcessoController.changeLoadingFichaFinaceira(false));
    }
  }

  const somatoriosDevedor = (obj) => {
    if (!obj?.valores) return 0;

    const {
      valorSaldoPrincipal = 0,
      valorMulta = 0,
      valorProtesto = 0,
      valorJurosCliente = 0,
      valorJurosABE = 0,
      valorHonorarios = 0,
    } = obj.valores;

    return (
      Number(valorSaldoPrincipal)
      + Number(valorMulta)
      + Number(valorProtesto)
      + Number(valorJurosCliente)
      + Number(valorJurosABE)
      + Number(valorHonorarios)
    );
  };

  const somatoriosCliente = (obj) => {
    if (!obj?.valores) return 0;

    const {
      valorSaldoPrincipal = 0,
      valorMulta = 0,
      valorProtesto = 0,
      valorJurosCliente = 0,
    } = obj.valores;

    return (
      Number(valorSaldoPrincipal)
      + Number(valorMulta)
      + Number(valorProtesto)
      + Number(valorJurosCliente)
    );
  };

  const somatoriosHb = (obj) => {
    if (!obj?.valores) return 0;

    const {
      valorJurosABE = 0,
      valorHonorarios = 0,
    } = obj.valores;

    return (
      Number(valorJurosABE)
      + Number(valorHonorarios)
    );
  };

  useEffect(() => {
    findDistribuicaoValoresFichaFinanceira(idProcesso).then((response) => {
      const { data } = response;
      setDadosPagamento(dadosPagamentoFactory(data?.cardPagamento));
      setDadosPagamentoDireto(dadosPagamentoFactory(data?.cardPagamentoDireto));
      setDadosInicio(dadosPagamentoFactory(data?.fichaFinanceiraInicio));
    }).catch(() => {
      setDadosPagamento(dadosPagamentoFactory());
      setDadosPagamentoDireto(dadosPagamentoFactory());
      setDadosInicio(dadosPagamentoFactory());
    });
    findResumoFichaFinanceira(idProcesso).then((response) => {
      const { data } = response;
      configureStatesResumo(data);
    }).catch(() => {
      setSettingsResumo({

      });
    });
  }, [idProcesso, configureStatesResumo]);

  return (
    <div className={style.container}>
      <LoadingUI />
      <div className={style.header}>
        <div>
          <div>
            <WrapperSubTitleForm title="Distribuição de Valores" />
            <div style={{ marginTop: '8px', fontSize: '12px' }}>
              <h1>
                - Distribuição na Ficha Financeira:
                <b>
                  {' '}
                  {settingsResumo.distribuicaoFichaFinanceira}
                </b>
              </h1>
              <h1>
                - Distribuição dos Valores pagos pelo Devedor:
                <b>
                  {' '}
                  {settingsResumo.distribuicaoValoresDevedor}
                </b>

              </h1>
              <h1>
                - Quitação de Títulos:
                <b>
                  {' '}
                  {settingsResumo.quitacaoTitulos}
                </b>
              </h1>
            </div>
          </div>
          <div>
            <ButtonImprimir
              onClick={handlePrintFichaFinanceira}
            >
              <MdPrintIcon size={16} />
              <span>Imprimir</span>

            </ButtonImprimir>
          </div>
        </div>
        <ContainerDistribuicaoValores>
          <WrapperSubTitleForm title="Detalhes da Distribuição de Valores" />
          <div className={style.distribuicaoValores}>
            <CardTop color="#F85861">
              <CardInfo>
                <p>Devedor</p>
                <HrColored color="#E9303B" />
                <p>
                  Início
                  {' '}
                  <span>
                    {
                      getMoneyMask(somatoriosDevedor(dadosInicio))
                    }
                  </span>
                </p>
                <HrColored color="#E9303B" />
                <p>
                  Pagamento
                  {' '}
                  <span>
                    {
                      getMoneyMask(somatoriosDevedor(dadosPagamento))
                    }
                  </span>
                </p>
                <HrColored color="#E9303B" />
                <p>
                  Pagto. Direto
                  {' '}
                  <span>
                    {
                      getMoneyMask(somatoriosDevedor(dadosPagamentoDireto))
                    }
                  </span>
                </p>
                <HrColored color="#E9303B" />
                <p>
                  Saldo
                  {' '}
                  <span>
                    {
                      getMoneyMask(
                        somatoriosDevedor(dadosInicio)
                        - (somatoriosDevedor(dadosPagamentoDireto) + somatoriosDevedor(dadosPagamento)),
                      )
                    }
                  </span>
                </p>
              </CardInfo>
            </CardTop>
            <CardTop color="#FF7B51">
              <CardInfo>
                <p>Cliente</p>
                <HrColored color="#FF521B" />
                <p>
                  Início
                  {' '}
                  <span>
                    {
                      getMoneyMask(somatoriosCliente(dadosInicio))
                    }
                  </span>
                </p>
                <HrColored color="#FF521B" />
                <p>
                  Pagamento
                  {' '}
                  <span>
                    {
                      getMoneyMask(somatoriosCliente(dadosPagamento))
                    }
                  </span>
                </p>
                <HrColored color="#FF521B" />
                <p>
                  Pagto. Direto
                  {' '}
                  <span>
                    {
                      getMoneyMask(somatoriosCliente(dadosPagamentoDireto))
                    }
                  </span>
                </p>
                <HrColored color="#FF521B" />
                <p>
                  Saldo
                  {' '}
                  <span>
                    {
                      getMoneyMask(
                        somatoriosCliente(dadosInicio)
                        - (somatoriosCliente(dadosPagamento) + somatoriosCliente(dadosPagamentoDireto)),
                      )
                    }
                  </span>
                </p>
              </CardInfo>
            </CardTop>
            <CardTop color="#FF449B">
              <CardInfo>
                <p>HB</p>
                <HrColored color="#E9207E" />
                <p>
                  Início
                  {' '}
                  <span>
                    {
                      getMoneyMask(somatoriosHb(dadosInicio))
                    }
                  </span>
                </p>
                <HrColored color="#E9207E" />
                <p>
                  Pagamento
                  {' '}
                  <span>
                    {
                      getMoneyMask(somatoriosHb(dadosPagamento))
                    }
                  </span>
                </p>
                <HrColored color="#E9207E" />
                <p>
                  Pagto. Direto
                  {' '}
                  <span>
                    {
                      getMoneyMask(somatoriosHb(dadosPagamentoDireto))
                    }
                  </span>
                </p>
                <HrColored color="#E9207E" />
                <p>
                  Saldo
                  {' '}
                  <span>
                    {
                      getMoneyMask(
                        somatoriosHb(dadosInicio)
                        - (somatoriosHb(dadosPagamento) + somatoriosHb(dadosPagamentoDireto)),
                      )
                    }
                  </span>
                </p>
              </CardInfo>
            </CardTop>
          </div>
          <div className={style.distribuicaoValores}>
            <CardTop color="#58A9F4">
              <CardInfo>
                <p>Negociador</p>
                <HrColored color="#3E71A0" />
                <p>
                  Início
                  {' '}
                  <span>
                    {
                      getMoneyMask(dadosInicio.valores?.valorNegociador)
                    }
                  </span>
                </p>
                <HrColored color="#3E71A0" />
                <p>
                  Pagamento
                  {' '}
                  <span>
                    {
                      getMoneyMask(dadosPagamento.valores?.valorNegociador)
                    }
                  </span>
                </p>
                <HrColored color="#3E71A0" />
                <p>
                  Pagto. Direto
                  {' '}
                  <span>
                    {
                      getMoneyMask(dadosPagamentoDireto.valores?.valorNegociador)
                    }
                  </span>
                </p>
                <HrColored color="#3E71A0" />
                <p>
                  Saldo
                  {' '}
                  <span>
                    {
                      getMoneyMask(
                        dadosInicio.valores?.valorNegociador
                        - (dadosPagamento.valores?.valorNegociador + dadosPagamentoDireto.valores?.valorNegociador),
                      )
                    }
                  </span>
                </p>
              </CardInfo>
            </CardTop>
            <CardTop color="#3373EC">
              <CardInfo>
                <p>DSR</p>
                <HrColored color="#2A55A6" />
                <p>
                  Início
                  {' '}
                  <span>
                    {
                      getMoneyMask(dadosInicio.valores?.valorDSR)
                    }
                  </span>
                </p>
                <HrColored color="#2A55A6" />
                <p>
                  Pagamento
                  {' '}
                  <span>
                    {
                      getMoneyMask(dadosPagamento.valores?.valorDSR)
                    }
                  </span>
                </p>
                <HrColored color="#2A55A6" />
                <p>
                  Pagto. Direto
                  {' '}
                  <span>
                    {
                      getMoneyMask(dadosPagamentoDireto.valores?.valorDSR)
                    }
                  </span>
                </p>
                <HrColored color="#2A55A6" />
                <p>
                  Saldo
                  {' '}
                  <span>
                    {
                      getMoneyMask(
                        dadosInicio.valores?.valorDSR
                        - (dadosPagamento.valores?.valorDSR + dadosPagamentoDireto.valores?.valorDSR),
                      )
                    }
                  </span>
                </p>
              </CardInfo>
            </CardTop>
            <CardTop color="#2B59B0">
              <CardInfo>
                <p>Comercial</p>
                <HrColored color="#0F3A8B" />
                <p>
                  Início
                  {' '}
                  <span>
                    {
                      getMoneyMask(dadosInicio.valores?.valorComercial)
                    }
                  </span>
                </p>
                <HrColored color="#0F3A8B" />
                <p>
                  Pagamento
                  {' '}
                  <span>
                    {
                      getMoneyMask(dadosPagamento.valores?.valorComercial)
                    }
                  </span>
                </p>
                <HrColored color="#0F3A8B" />
                <p>
                  Pagto. Direto
                  {' '}
                  <span>
                    {
                      getMoneyMask(dadosPagamentoDireto.valores?.valorComercial)
                    }
                  </span>
                </p>
                <HrColored color="#0F3A8B" />
                <p>
                  Saldo
                  {' '}
                  <span>
                    {
                      getMoneyMask(
                        dadosInicio.valores?.valorComercial
                        - (dadosPagamento.valores?.valorComercial + dadosPagamentoDireto.valores?.valorComercial),
                      )
                    }
                  </span>
                </p>
              </CardInfo>
            </CardTop>
            <CardTop color="#1D3970">
              <CardInfo>
                <p>Advogado</p>
                <HrColored color="#173061" />
                <p>
                  Início
                  {' '}
                  <span>
                    {
                      getMoneyMask(dadosInicio.valores?.valorAdvogado)
                    }
                  </span>
                </p>
                <HrColored color="#173061" />
                <p>
                  Pagamento
                  {' '}
                  <span>
                    {
                      getMoneyMask(dadosPagamento.valores?.valorAdvogado)
                    }
                  </span>
                </p>
                <HrColored color="#173061" />
                <p>
                  Pagto. Direto
                  {' '}
                  <span>
                    {
                      getMoneyMask(dadosPagamentoDireto.valores?.valorAdvogado)
                    }
                  </span>
                </p>
                <HrColored color="#173061" />
                <p>
                  Saldo
                  {' '}
                  <span>
                    {
                      getMoneyMask(
                        dadosInicio.valores?.valorAdvogado
                        - (dadosPagamento.valores?.valorAdvogado + dadosPagamentoDireto.valores?.valorAdvogado),
                      )
                    }
                  </span>
                </p>
              </CardInfo>
            </CardTop>
          </div>
        </ContainerDistribuicaoValores>

      </div>
      <div style={{
        width: '55%', color: blue, fontSize: '12px', fontWeight: 'bold', marginBottom: '12px',
      }}
      >
        Visões:

      </div>
      <TabCardLayoutAccordion
        tabItems={tabItens}
        parentStates={[activeTab, changeTabViewHandler]}
      />
      <div>
        <TabPanel id={tabItens[0].id} index={tabItens[0].index} value={activeTab}>
          <div>
            <FichaAnalíticaComponent
              idProcesso={idProcesso}
              setLoadings={setLoadings}
              columnOrdenacao={columnOrdenacaoAnalitica}
              setColumnOrdenacao={setColumnOrdenacaoAnalitica}
            />
          </div>
        </TabPanel>
        <TabPanel id={tabItens[1].id} index={tabItens[1].index} value={activeTab}>
          <FichaSinteticaComponent
            idProcesso={idProcesso}
            setLoadings={setLoadings}
            columnOrdenacao={columnOrdenacaoSintetica}
            setColumnOrdenacao={setColumnOrdenacaoSintetica}
          />
        </TabPanel>

      </div>
    </div>
  );
}

export const FichaFinanceira = FichaFinanceiraComponent;
